/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/334-sort-amount-desc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 12V0H3v12H.5L4 15.5 7.5 12H5zM7 0h9v2H7V0zM7 3h7v2H7V3zM7 6h5v2H7V6z"/><path pid="1" d="M7 9h3v2H7V9z"/>'
  }
})
